import { store } from "../Redux/Store";
import Type from "../Redux/Type"
import LinkAPI, { onPostRequest } from './MainController';

export const onLoadViTriDiaGioi = () => {
    let onSuccess = ({ statusCode, response }) => {
        if (statusCode === 200) {

            let arHuyen = response.filter(e => e.MaXa === 0);
            arHuyen.map(item => {
                let arrXa = response.filter(e => e.MaHuyen === item.MaHuyen && e.MaXa !== 0)
                item.arrXa = arrXa
            })
            store.dispatch({ type: Type.SET_DIAGIOI, route: 'menuDiaGioi', value: arHuyen })
            store.dispatch({ type: Type.SET_DIAGIOI, route: 'huyenselect', value: arHuyen.length > 0 ? { key: arHuyen[0].key, text: arHuyen[0].text } : null })

        }
    }
    onPostRequest(LinkAPI.getDiaGioiHanhChinh, onSuccess)
}

export const onLoadXa = (huyenobject) => {
    store.dispatch({ type: Type.SET_DIAGIOI, route: 'huyenselect', value: null })
    store.dispatch({ type: Type.SET_DIAGIOI, route: 'huyenselect', value: huyenobject })
}




